<div class="col-12">
  <p-tabView (onChange)="getTaxDefinitions($event)">
    <p-tabPanel
      *ngFor="let country of countrySearchResults"
      [header]="country.name"
    >
    </p-tabPanel>
  </p-tabView>
</div>

<form [formGroup]="addTaxDefinitionFormGroup">
  <div class="p-formgroup-inline">
    <div *ngIf="countryDetailsResults?.length; else no_tax_definitions">
      <p-table
        [value]="countryDetailsResults"
        styleClass="p-datatable-gridlines"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Tax Name</th>
            <th colspan="2">Percentage</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-taxDefinition>
          <tr>
            <td class="m-0">
              {{ taxDefinition.name }}
            </td>
            <td class="m-0">
              {{ taxDefinition.rate }}
            </td>
            <td class="m-0">
              <div class="field-checkbox">
                <p-checkbox
                  name="taxes"
                  [value]="taxDefinition.id"
                  [(ngModel)]="selectedTaxValues"
                  [ngModelOptions]="{ standalone: true }"
                  (onChange)="
                    submitTaxDefinition(taxDefinition.id, $event.checked)
                  "
                ></p-checkbox>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <ng-template #no_tax_definitions
    >There are no Available Tax Definitions for this country.</ng-template
  >
</form>
